<template>
    <section class="overflow-hidden">
        <div class="w-full inline-flex flex-nowrap relative group py-6 bg-[#080808]">
            <div
                class="h-full absolute lg:block hidden pointer-events-none right-0 bg-gradient-to-l from-gray-950 top-1/2 -translate-y-1/2 w-[170px] z-30"
            ></div>

            <ul
                class="flex gap-x-4 mx-4 items-center justify-center md:justify-start animate-infinite-scroll group-hover:[animation-play-state:paused]"
            >
                <div  v-for="item in items" class="w-80 h-16 relative flex justify-center">
                    <NuxtImg
                        class=" h-16 peer"
                        :alt="item.alt"
                        :src="item.img.src"
                    />
                </div>
            </ul>
            <ul
                class="flex gap-x-4 items-center justify-center md:justify-start animate-infinite-scroll group-hover:[animation-play-state:paused]"
                aria-hidden="true"
            >
                <div v-for="item in items" class="w-80 h-16 text-red-100 relative flex justify-center">
                    <NuxtImg
                        class=" h-16 peer"
                        :alt="item.alt"
                        :src="item.img.src"
                    />
                </div>
            </ul>
            <ul
                class="flex gap-x-4 items-center justify-center md:justify-start animate-infinite-scroll group-hover:[animation-play-state:paused]"
                aria-hidden="true"
            >
                <div v-for="item in items" class="w-80 h-16 text-red-100 relative flex justify-center">
                    <NuxtImg
                        :placeholder="placeholderResolver(item.img.src)"
                        class=" h-16 peer"
                        :alt="item.alt"
                        :src="item.img.src"
                    />
                </div>
            </ul>
            <ul
                class="flex gap-x-4 items-center justify-center md:justify-start animate-infinite-scroll group-hover:[animation-play-state:paused]"
                aria-hidden="true"
            >
                <div v-for="item in items" class="w-80 h-16 text-red-100 relative flex justify-center">
                    <NuxtImg
                        class=" h-16 peer"
                        :alt="item.alt"
                        :src="item.img.src"
                    />
                </div>
            </ul>
            <div
                class="h-full absolute lg:block hidden pointer-events-none left-0 bg-gradient-to-r from-gray-950 top-1/2 -translate-y-1/2 w-[170px] z-30"
            ></div>
        </div>
    </section>
</template>

<script setup lang="ts">
const { t } = useI18n();

const items = [
    {
        link: "/dashboard/upload-photo/service-backsplash",
        id: "service-backsplash",
        text: t("global_serviceName_backSplashChange"),
        alt: t("global_serviceName_backSplashChange"),
        img: {
            src: "/homepage/retailers/century-21-logo.png",
        },
    },
    {
        link: "/dashboard/upload-photo/service-ceiling-change",
        id: "service-ceiling-change",
        text: t("global_serviceName_ceilingChange"),
        alt: t("global_serviceName_ceilingChange"),
        img: {
            src: "/homepage/retailers/keller-williams.png",
        },
    },
    {
        link: "/dashboard/upload-photo/service-creative-designer",
        id: "service-creative-designer",
        text: t("global_serviceName_creativeDesigner"),
        alt: t("global_serviceName_creativeDesigner"),
        img: {
            src: "/homepage/retailers/home-smart.png",
        },
    },
    {
        link: "/dashboard/upload-photo/service-change-the-floor",
        id: "service-change-the-floor",
        text: t("global_serviceName_floorChange"),
        alt: t("global_serviceName_floorChange"),
        img: {
            src: "/homepage/retailers/compass.png",
        },
    },
    {
        link: "/dashboard/upload-photo/service-replace-furniture",
        id: "service-replace-furniture",
        text: t("global_serviceName_furnitureReplacement"),
        alt: t("global_serviceName_furnitureReplacement"),
        img: {
            src: "/homepage/retailers/exp.png",
        },
    },
    {
        link: "/dashboard/upload-photo/service-change-your-wall",
        id: "service-change-your-wall",
        text: t("global_serviceName_wallChange"),
        alt: t("global_serviceName_wallChange"),
        img: {
            src: "/homepage/retailers/realator.png",
        },
    },

];
</script>
